import { HelmetDexteel } from "@dexteel/mesf-core";
import { BilletsRFactorReport } from "./components/BilletsRFactorReport";

export const BilletsRFactorPage = () => {
	return (
		<>
			<HelmetDexteel title="Billets R-Factor" />
			<BilletsRFactorReport />
		</>
	);
};
